exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapsed[data-v-545e28df] {\n  -webkit-transition: opacity 1s;\n  transition: opacity 1s;\n}\n.info-fullname[data-v-545e28df] {\n  max-width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.user-info .caret[data-v-545e28df] {\n  top: -12px !important;\n}\n", ""]);

// exports
